var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9146ff",
  d: "M77.14 31.427h11.433v34.286h-11.44Zm31.433 0H120v34.286h-11.427ZM40 0 11.427 28.573v102.854h34.286V160l28.574-28.573H97.14L148.573 80V0Zm97.14 74.287L114.287 97.14h-22.86l-20 20v-20H45.713V11.427h91.427Z"
})));

export default SvgTwitch;